import '@i18n/i18n';
import './styles/index.css';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import routes from 'src/configs/routesConfig';
import { initOtel, logErrorToOtel } from '@/lib/telemetry/otel';

// Initialise OpenTelemetry. No-op when VITE_OTEL_ENDPOINT is unset
// (i.e. local dev without an OTel collector running). Done at module
// load so auto-instrumentations capture the very first fetch / XHR.
initOtel();
// Mock API disabled - using real API integration
// import { worker } from '@mock-utils/mswMockAdapter';
// import { API_BASE_URL } from '@/utils/api';

// Mock API disabled for real API integration
// async function mockSetup() {
// 	return worker.start({
// 		onUnhandledRequest: 'bypass',
// 		serviceWorker: {
// 			url: `${API_BASE_URL}/mockServiceWorker.js`
// 		}
// 	});
// }

/**
 * The root element of the application.
 */
const container = document.getElementById('app');

if (!container) {
	throw new Error('Failed to find the root element');
}

// Directly start the app without mock setup
/**
 * The root component of the application.
 */
const root = createRoot(container, {
	onUncaughtError: (error, errorInfo) => {
		console.error('UncaughtError error', error, errorInfo.componentStack);
		logErrorToOtel(error, {
			source: 'reactRoot.onUncaughtError',
			componentStack: errorInfo.componentStack ?? undefined
		});
	},
	onCaughtError: (error, errorInfo) => {
		console.error('Caught error', error, errorInfo.componentStack);
		logErrorToOtel(error, {
			source: 'reactRoot.onCaughtError',
			componentStack: errorInfo.componentStack ?? undefined
		});
	}
});

const router = createBrowserRouter(routes);

root.render(<RouterProvider router={router} />);
